import React from 'react';

const NoInvoicesNewCustomer = (props) => {

  return (

    <div className="no-invoices-container">
      {/* <div className="new-customer-text">ברוכים הבאים לסלקום</div> */}
      {/* <div className="new-invoices-date">החשבונית הראשונה שלך תופיע כאן החל מ-{props.billCycle}</div> */}
      <div className="new-invoices-date">אוטוטו, ב {props.billCycle} , תופיע כאן החשבונית הראשונה שלך</div>
    </div>

  );
};
export default NoInvoicesNewCustomer;
